import { get } from "@insite/client-framework/Services/ApiService";


const rewardsUrl = "/api/v1/rewards/token";


export function getRewardsService(){
    return get<any>(`${rewardsUrl}`);
}
